"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_QUERY_KEY = exports.QUERY_KEYS = void 0;
exports.QUERY_KEYS = {
    getPrices: 'get-prices',
    auth: 'auth',
    confirmAuth: 'confirmAuth',
    getProfile: 'getProfile',
    registration: 'registration',
    submitOrder: 'submitOrder',
    updateProfile: 'updateProfile',
    initOrder: 'initOrder',
    completePayment: 'completePayment',
    getRisk: 'getRisk',
};
exports.DOCUMENT_QUERY_KEY = 'kei-file';
